import { render, staticRenderFns } from "./EmergencyContact.vue?vue&type=template&id=30a09322&scoped=true"
import script from "./EmergencyContact.vue?vue&type=script&lang=js"
export * from "./EmergencyContact.vue?vue&type=script&lang=js"
import style0 from "./EmergencyContact.vue?vue&type=style&index=0&id=30a09322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a09322",
  null
  
)

export default component.exports